import { ToolsAPI } from "@/lib/api"
import {
  SET_TOOLS,
  SET_ASSIGNED_TOOLS,
  ASSIGN_TOOL,
  UNASSIGN_TOOL
} from "@/store/mutationTypes"

const state = {
  all: [],
  assigned: []
}

// getters
const getters = {
  getTools: (state, getters) => {
    return state.all
  },
  getAssignedTools: (state, getters) => id => {
    return state.assigned
  }
}

// actions
const actions = {
  async loadTools({ commit }) {
    const data = await ToolsAPI.list()
    commit(SET_TOOLS, data)
  },
  async loadAssignedTools({ commit }, userId) {
    const data = await ToolsAPI.listAssignments(userId)
    commit(SET_ASSIGNED_TOOLS, data)
  },
  async assignTool({ commit }, { name, userId }) {
    let toolAssignment = await ToolsAPI.assign(name, userId)
    commit(ASSIGN_TOOL, toolAssignment)
  },
  async unassignTool({ commit }, id) {
    await ToolsAPI.unassign(id)
    commit(UNASSIGN_TOOL, id)
  }
}

const mutations = {
  [SET_TOOLS](state, tools) {
    state.all = tools
  },
  [SET_ASSIGNED_TOOLS](state, tools) {
    state.assigned = tools
  },
  [ASSIGN_TOOL](state, tool) {
    state.assigned.push(tool)
  },
  [UNASSIGN_TOOL](state, id) {
    let index = state.assigned.findIndex(el => el.id === id)
    state.assigned.splice(index, 1)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
